
export function isEquationValid(options: Array<{num: number, formula: string}>) {
  const equationMap = options.reduce((res, cur) => {
    const matches = cur.formula.match(/[A-Z][a-z]?(_{\d+})?/g)
    matches?.forEach((item) => {
      const [_t, elem, _a, numStr] = item.match(/([A-Z][a-z]?)(_{(\d+)})?/) || []
      if (elem) {
        const elemCount = (!!numStr ? Number(numStr) : 1) * cur.num
        if (!res[elem]) {
          res[elem] = elemCount
        } else {
          res[elem] += elemCount
        }
      }
    })
    return res;
  }, {})

  return Object.values(equationMap).filter(item => item !== 0).length === 0
}